module.exports = __webpack_public_path__ + "static/media/shema-light@3x-En.31dd7a76.png";